import React, { Component } from 'react'
import "bootstrap/dist/css/bootstrap.css";
import { TableRow, TableCell, Link } from '@aws-amplify/ui-react';
import { Link as Router_Link } from 'react-router-dom';
import { Trash } from 'react-bootstrap-icons';

class SavedSearchRow extends Component {
    render() {
        return (
            <TableRow>
                <TableCell>
                {this.props.index+1}
                </TableCell>
                <TableCell>
                    <Router_Link as={Link} to={'/'+this.props.entity.type+'serachreports?id=' + this.props.entity.id}>
                        {this.props.entity.report_name}
                    </Router_Link>
                </TableCell>
                <TableCell>
                    {this.props.entity.type}
                </TableCell>
                <TableCell>
                    {this.props.entity.date.substring(0, 10)}
                </TableCell>
                <TableCell>
                        <Link className='App-link text-center' onClick={() => this.props.onDelete(this.props.entity)}>
                            <Trash/>
                        </Link>
                    </TableCell>
            </TableRow>
        )
    }
}
export default SavedSearchRow;